import { useState } from "react";
import TextInput from "../../components/TextInput";
import Button from "../../components/Button";
import Card from "../../components/Card";

import { Link } from "react-router-dom";
import Text from "../../components/Text";
import { AuthService } from "../../services/AuthService";


interface RegisterData {
    email: string,
    username: string,
    password: string,
    confirmPassword: string
}

const Register = () => {

    const [registerData, setRegisterData] = useState<RegisterData>({
        email: null,
        username: null,
        password: null,
        confirmPassword: null,

    })

    const [loading, setLoading] = useState(false);


    const handleRegister = async (e) => {
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
        }, 3000);

    };
    return (
        <div className="form-wrapper">
            <div className="form-container" style={{ marginLeft: "auto", marginRight: "auto", maxWidth: "400px" }}>
                <Card>

                    <h1>Register</h1>
                    <form onSubmit={handleRegister}>

                        <TextInput type="text" id="email" value={registerData?.email} onChangeValue={(text) => setRegisterData({ ...registerData, email: text })} placeholder="Email" style={{ marginBottom: "10px" }} />

                        <TextInput type="text" id="username" value={registerData?.username} onChangeValue={(text) => setRegisterData({ ...registerData, username: text })} placeholder="Username" style={{ marginBottom: "10px" }} />

                        <TextInput type="password" id="password" value={registerData?.password} onChangeValue={(text) => setRegisterData({ ...registerData, password: text })} placeholder="Password" style={{ marginBottom: "10px" }} />

                        <TextInput type="password" id="confirm_password" value={registerData?.confirmPassword} onChangeValue={(text) => setRegisterData({ ...registerData, confirmPassword: text })} placeholder="Confirm Password" style={{ marginBottom: "20px" }} />

                        <Button loading={loading} text="Register" onPress={() => alert("ha")} />
                    </form>

                    <div style={{ marginTop: "2rem" }}>
                        <p className="text-center" style={{ marginBottom: "10px" }}>Already have an account?</p>



                        <Link to="/login" className="text-center">Login</Link>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default Register;